import { GET_STATS, SET_RANGE, GET_DASHBOARD_CUSTOMERS, GET_DASHBOARD_ORDERS } from './types';

export const setRange = rangeValue => ({
  type: SET_RANGE,
  payload: rangeValue,
});

export const getCustomers = (filter = { limit: 5 }) => ({
  type: GET_DASHBOARD_CUSTOMERS,
  payload: filter,
});

export const getOrders = (restaurantId, filter = { limit: 5 }) => ({
  type: GET_DASHBOARD_ORDERS,
  payload: { restaurantId, filter },
});

export const getStats = range => ({
  type: GET_STATS,
  payload: { range },
});



// WEBPACK FOOTER //
// ./src/actions/dashboard.actions.js